import React from 'react'
import blobPath from './MyMapUtils/blobPath'
import GetfacilityTypeData from './MyMapUtils/GetfacilityTypeData';

export default function SearchResultItemPhoto(props) {

    return (   
        <div className="sr-itemcontainer"
            id={props.data?.id}
            onMouseEnter={() => props.onEnterItem(props.data) }    
            onMouseLeave={() => props.onLeaveItem(props.data) }
        >
            <a className="sr-a" rel='noopener noreferrer' href="/#">{null}</a>
            <div className="sr-item">
                <div className="sr-flex">
                    <div className="sr-flex-icon">
                        <div className="sr-flex-icondiv">
                            <img decoding="async" className="sr-item-icon" src={GetfacilityTypeData(props.data.type,"icon")}
                                aria-hidden="true" alt="" />
                        </div>
                    </div>
                    <div className="sr-flex-info">
                            <div className="sr-flex-infodiv">
                                <div className="sr-item-title">
                                    <div className="sr-item-titlevalue">
                                        <span style={{ fontWeight: 'bold' }}>{props.data.title}</span>
                                    </div>
                                </div>
                                <div className="sr-item-property"><span>アップロード日時：{props.data.uploadDateTime}</span></div>
                                <div className="sr-item-property"><span>撮影日時　　　　：{props.data.filmingDateTime}</span></div>
                                <div className="sr-item-property">
                                    <div style={{width: "100%"}}>
                                        {props.data.tags !== undefined && props.data.tags !== null && props.data.tags.length !== 0 ? props.data.tags.map((item,index) =>
                                            <button onClick={()=>props.onTagClick(`#${item}`)} className="link-style-btn photoResult_tag" style={{ fontWeight: 'bold',wordBreak: "break-all",wordWrap: "break-word",textAlign:"left" }} key={index}>#{item}</button> ) : ""}
                                    </div>
                                </div>
                            </div>
                        </div>
                    <div className="sr-flex-img">
                        <div className="sr-flex-imgdiv">
                            <a href={blobPath(props.data?.PhotoURL)} target="_blank" rel="noopener noreferrer">
                                <img decoding="async" className="sr-item-img"
                                    src={blobPath(props.data.ThumbnailURL === null ? props.data.PhotoURL : props.data.ThumbnailURL)}
                                    aria-hidden="true" alt="" target="_blank"
                                    onMouseEnter={(e) => props.onEnterImg(e, (props.data?.ThumbnailURL === null ? props.data.PhotoURL : props.data.ThumbnailURL)) }    
                                    onMouseLeave={(e) => props.onLeaveImg(e, (props.data?.ThumbnailURL === null ? props.data.PhotoURL : props.data.ThumbnailURL)) }
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="sr-line"></div>
        </div>
    );
}